module.exports = "<div class=banque-option> <div class=icon-col> <div class=icon-wrap ng-if=\"::option.id != null && !option.$notBank\"> <logo-contrepartie contrepartie-id={{::option.id}} contrepartie-type=FINANCEUR_SUBVENTION size=icon></logo-contrepartie> </div> </div> <div class=label-col> <span class=label>{{::option.libelleCourtUsuel}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/financeurOption.html
// module id = 948
// module chunks = 13